import { CHService } from "@app/project/model/ch-service";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { CommandHelper, CommandProviders } from "./command";
import { ServiceCommand, ServiceCommandData } from "./service-command";

export interface ServiceOperationCommand extends ServiceCommand {
    operation: string;
    args: Record<string, unknown>;
}

export interface ServiceOperationCommandData extends ServiceCommandData {
    operation: string;
    args: Record<string, unknown>;
}

export const isServiceOperation = (command: ServiceCommand): command is ServiceOperationCommand =>
    command.commandType === CommandProviders.SERVICE_OPERATION;

export class ServiceOperationCommandHelper extends CommandHelper {
    static readonly importMap: ImportMap<ServiceOperationCommand, ServiceOperationCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "uid", o: "serviceUid" },
        { i: "cpid", o: "controlPointId" },
        { i: "operation", o: "operation" },
        { i: "args", o: "args" },
    ];

    static exportObject(rule, command, importMap) {
        const newArgs = {};
        let index = 0;
        Object.values(command.args || {}).forEach(arg => {
            newArgs["" + index] = arg;
            index++;
        });
        command.args = newArgs;

        return ClassImporterExporter.exportObject(command, importMap, false);
    }

    static fromCHObject(command, steps?): ServiceOperationCommand {
        return {
            name: command[this.importMap[0].i],
            commandId: command[this.importMap[1].i],
            commandType: command[this.importMap[2].i],
            serviceUid: command[this.importMap[3].i],
            controlPointId: command[this.importMap[4].i],
            operation: command[this.importMap[5].i],
            args: command[this.importMap[6].i],
            service: null,
        };
    }

    static getDefault(service: CHService): ServiceOperationCommand {
        return {
            name: "Do Something",
            commandId: null,
            commandType: CommandProviders.SERVICE_OPERATION,
            serviceUid: service.instanceId,
            controlPointId: null,
            operation: null,
            args: {},
            service,
        };
    }
}
